import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { wipquantityresponse } from './wip-quantity-response';

export class WipQuantityResponseModel extends GlobalResponseObject{
    data?: wipquantityresponse;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //LotCodeDropDown
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: wipquantityresponse) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
